import React, { useEffect, useRef, useState } from "react";
import "./SplashScreen.css";

const SplashScreen = () => {
  const [hidden, setHidden] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const reducedMotion = window.matchMedia?.(
      "(prefers-reduced-motion: reduce)"
    )?.matches;

    const fallbackDuration = reducedMotion ? 450 : 3350;

    document.body.classList.add("splash-active");

    const timer = window.setTimeout(() => {
      setHidden(true);
      document.body.classList.remove("splash-active");
    }, fallbackDuration);

    const video = videoRef.current;

    if (video && !reducedMotion) {
      video.play().catch(() => {});
    }

    return () => {
      window.clearTimeout(timer);
      document.body.classList.remove("splash-active");
    };
  }, []);

  if (hidden) return null;

  return (
    <div className="paper-video-splash" aria-hidden="true">
      <video
        ref={videoRef}
        className="paper-video-splash__video"
        src="/splash-paper.mp4"
        muted
        playsInline
        autoPlay
        preload="auto"
      />

      <div className="paper-video-splash__tint" />
      <div className="paper-video-splash__grain" />
    </div>
  );
};

export default SplashScreen;
